(() => {
  let timer, queued = false;
  const update = () => {
    clearTimeout(timer); queued = false;
    let next = Infinity;
    document.querySelectorAll('[data-offer-deadline]').forEach(node => {
      const raw = node.dataset.offerDeadline;
      if (!raw) return;
      const end = Date.parse(raw);
      if (!Number.isFinite(end) || Date.now() >= end) node.hidden = true;
      else next = Math.min(next, end);
    });
    if (Number.isFinite(next)) timer = setTimeout(update, Math.min(Math.max(next-Date.now()+100,100),2147483647));
  };
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  const start = () => { update(); new MutationObserver(queue).observe(document.body,{childList:true,subtree:true}); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)update();});
})();
